import React, { useEffect } from "react";
import styled from "styled-components";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import HomePage from "../pages/HomePage";
import { sendPageViewsAnalytics } from "../utils/googleAnalytics";
import Navigation from "../components/Navigation";
import ContactPage from "../pages/ContactPage";
import AboutPage from "../pages/AboutPage";
import PortfolioPage from "../pages/PortfolioPage";
import SkillsPage from "../pages/SkillsPage";

const history = createBrowserHistory();
history.listen(sendPageViewsAnalytics);

export default function AppRouter() {
  /**
   * history.listen doesnt handle the first page load
   * so it needs to be triggered manually
   */
  useEffect(() => sendPageViewsAnalytics(history.location), []);

  return (
    <Router history={history}>
      <Navigation />
      <Content>
        <Switch>
          <Route path="/contact">
            <ContactPage />
          </Route>
          <Route path="/portfolio">
            <PortfolioPage />
          </Route>
          <Route path="/skills">
            <SkillsPage />
          </Route>
          <Route path="/about">
            <AboutPage />
          </Route>
          <Route path="/">
            <HomePage />
          </Route>
        </Switch>
      </Content>
    </Router>
  );
}

const Content = styled.div`
  flex: 1;
  overflow: hidden;
`;
